var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIonicIosEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.003,
    height: 9.644,
    viewBox: "0 0 15.003 9.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-eye",
    "data-name": "Icon ionic-ios-eye",
    transform: "translate(-2.252 -7.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10462",
    "data-name": "Path 10462",
    d: "M9.745,7.875c-2.692,0-4.815,1.694-7.353,4.464a.529.529,0,0,0,0,.713c2.173,2.4,4.089,4.467,7.357,4.467,3.228,0,5.649-2.6,7.37-4.487a.525.525,0,0,0,.017-.693C15.377,10.212,12.95,7.875,9.745,7.875Zm.147,7.832a3.014,3.014,0,1,1,2.87-2.87A3.015,3.015,0,0,1,9.892,15.707Z",
    transform: "translate(0)",
    fill: "#0267c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10463",
    "data-name": "Path 10463",
    d: "M15.652,14.072a1.58,1.58,0,0,1,.1-.568c-.034,0-.067,0-.1,0A2.151,2.151,0,1,0,17.8,15.652c0-.044,0-.087,0-.131a1.491,1.491,0,0,1-.612.131A1.561,1.561,0,0,1,15.652,14.072Z",
    transform: "translate(-5.9 -2.955)",
    fill: "#0267c1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIonicIosEye);
export default __webpack_public_path__ + "static/media/Icon_ionic_ios_eye.082032ce3c8b73c3e41af9069b73602d.svg";
export { ForwardRef as ReactComponent };